import { lazy } from "react";

// route
export const salesRoute = { path: "/sales", name: "menu.sales", icon: "point_of_sale" };
export const sQuotationRoute = { path: `${salesRoute.path}/quotation`, name: "Penawaran", code: 'QP' };
export const sQuoCreateRoute = { path: `${sQuotationRoute.path}/create`, name: "Buat Penawaran", code: 'QP' };
export const sQuoViewRoute = { path: `${sQuotationRoute.path}/view`, name: "Detail Penawaran", code: 'QP' };
export const sQuoProcessRoute = { path: `${sQuotationRoute.path}/process`, name: "Process Permintaan Penawaran", code: 'QP' };

export const sSORoute = { path: `${salesRoute.path}/so`, name: "sales_so.", code: 'SO' };
export const sSOViewRoute = { path: `${sSORoute.path}/view`, name: "sales_so.detail", code: 'SO' };
export const sSOCreateRoute = { path: `${sSORoute.path}/create`, name: "sales_so.add", code: 'SO' };
export const sSOUpdateRoute = { path: `${sSORoute.path}/edit`, name: "sales_so.edit", code: 'SO' };
export const sDOOutCreateRoute = { path: `${sSORoute.path}/do/create`, name: "sales_so.do", code: 'SO' };

export const sPORoute = { path: `${salesRoute.path}/po`, name: "sales_so.po", code: 'SO' };
export const sPOViewRoute = { path: `${sPORoute.path}/view`, name: "sales_so.po_detail", code: 'SO' };

export const sRefItemOutRoute = { path: `${salesRoute.path}/do`, name: "Delivery Order", code: 'DOOUT' };
export const sRefItemOutViewRoute = { path: `${sRefItemOutRoute.path}/view`, name: "Detail Delivery Order", code: 'DOOUT' };

export const sInvoiceRoute = { path: `${salesRoute.path}/invoice`, name: "sales_invoice.", code: 'INVS' };
export const sInvoiceCreateRoute = { path: `${sInvoiceRoute.path}/create`, name: "sales_invoice.add", code: 'INVS' };
export const sInvoiceUpdateRoute = { path: `${sInvoiceRoute.path}/edit`, name: "sales_invoice.edit", code: 'INVS' };
export const sInvoiceViewRoute = { path: `${sInvoiceRoute.path}/view`, name: "sales_invoice.detail", code: 'INVS' };

export const sReturnCusRoute = { path: `${salesRoute.path}/returnCustomer`, name: "sales_returncustomer.", code: 'RCP' };
export const sPriceStockRoute = { path: `${salesRoute.path}/price-stock`, name: "sales_priceStock.", code: 'PriSto' };

export const sInvRecapRoute = { path: `${salesRoute.path}/recap`, name: "sales_recap.", code: 'RINV' };
export const sInvRecapCreateRoute = { path: `${sInvRecapRoute.path}/create`, name: "sales_recap.add", code: 'RINV' };
export const sInvRecapViewRoute = { path: `${sInvRecapRoute.path}/view`, name: "sales_recap.detail", code: 'RINV' };

// component
const Sales = lazy(() => import("../page/sales/Sales"));
const SalesSO = lazy(() => import("../page/sales/so/SalesSO"));
const SalesSOView = lazy(() => import("../page/sales/so/view/SOView"));
const SalesSOForm = lazy(() => import("../page/sales/so/form/SalesSOForm"));
const SalesDOOutForm = lazy(() => import("../page/sales/so/form_do_out/DOOutForm"));

const SalesPO = lazy(() => import("../page/sales/po/SalesPO"));
const SalesPOView = lazy(() => import("../page/sales/po/view/SalesPOView"));

const SalesRefItemOut = lazy(() => import("../page/sales/ref_item_out/SalesRefItemOut"));
const SalesRefItemOutView = lazy(() => import("../page/sales/ref_item_out/view/SalesRefItemOutView"));

const SalesQuotation = lazy(() => import("../page/sales/quotation/SalesQuotation"));
const SalesQuotationForm = lazy(() => import("../page/sales/quotation/form/SalesQuotationForm"));
const SalesQuotationProcessForm = lazy(() => import("../page/sales/quotation_mitra/form_process/SalesQuotationProcessForm"));
const SalesQuotationMain = lazy(() => import("../page/sales/SalesQuotationMain"));

const SalesInvoice = lazy(() => import("../page/sales/invoice/SalesInvoice"));
const SalesInvoiceForm = lazy(() => import("../page/sales/invoice/form/SalesInvoiceForm"));
const SalesInvoiceView = lazy(() => import("../page/sales/invoice/view/SalesInvoiceView"));

const SalesReturCus = lazy(() => import("../page/sales/return_customer/SalesReturnCustomer"));
const SalesPriceStock = lazy(() => import("../page/sales/price_stock_list/SalesPriceStockList"));

const SalesRecapInv = lazy(() => import("../page/sales/recap/SalesInvRecap"));
const SalesRecapInvForm = lazy(() => import("../page/sales/recap/form/SalesInvRecapForm"));
const SalesRecapInvView = lazy(() => import("../page/sales/recap/view/SalesInvRecapView"));

export const salesMainTabRoutes = [
    sQuotationRoute, sSORoute,
    sRefItemOutRoute, sInvoiceRoute, sReturnCusRoute,
    sInvRecapRoute, sPriceStockRoute
];

export const salesMutationRoutes = [
    sQuoCreateRoute, sQuoViewRoute, sQuoProcessRoute,
    sSOCreateRoute, sSOUpdateRoute, sSOViewRoute, sDOOutCreateRoute,
    sPORoute, sPOViewRoute,
    sRefItemOutViewRoute,
    sInvoiceCreateRoute, sInvoiceUpdateRoute, sInvoiceViewRoute,
    sInvRecapCreateRoute, sInvRecapViewRoute
];

export const salesRoutes = {
    element: <Sales />,
    children: [
        { ...sQuotationRoute, element: <SalesQuotation /> },
        { ...sQuoCreateRoute, element: <SalesQuotationForm /> },
        { ...sQuoViewRoute, element: <SalesQuotationMain type="view" /> },
        { ...sQuoProcessRoute, element: <SalesQuotationProcessForm /> },
        { ...sPORoute, element: <SalesPO /> },
        { ...sPOViewRoute, element: <SalesPOView /> },
        { ...sSORoute, element: <SalesSO /> },
        { ...sSOCreateRoute, element: <SalesSOForm /> },
        { ...sSOUpdateRoute, element: <SalesSOForm /> },
        { ...sSOViewRoute, element: <SalesSOView /> },
        { ...sDOOutCreateRoute, element: <SalesDOOutForm /> },
        { ...sRefItemOutRoute, element: <SalesRefItemOut /> },
        { ...sRefItemOutViewRoute, element: <SalesRefItemOutView /> },
        { ...sInvoiceRoute, element: <SalesInvoice /> },
        { ...sInvoiceCreateRoute, element: <SalesInvoiceForm /> },
        { ...sInvoiceUpdateRoute, element: <SalesInvoiceForm /> },
        { ...sInvoiceViewRoute, element: <SalesInvoiceView /> },
        { ...sReturnCusRoute, element: <SalesReturCus /> },
        { ...sInvRecapRoute, element: <SalesRecapInv /> },
        { ...sInvRecapCreateRoute, element: <SalesRecapInvForm /> },
        { ...sInvRecapViewRoute, element: <SalesRecapInvView /> },
        { ...sPriceStockRoute, element: <SalesPriceStock /> },
    ],
};